import { jsx as d, jsxs as a, Fragment as z } from "react/jsx-runtime";
import { forwardRef as A, useRef as M, useState as t, useEffect as W } from "react";
import b from "classnames";
import k from "autosize";
import q from "../FieldContainer/index.js";
import D from "../../helpers/nanoid.js";
import G from "../../hooks/useRefWithForm.js";
const H = "forma-ui__textarea__input", J = "forma-ui__textarea__withIcon", K = "forma-ui__textarea__readonly", O = "forma-ui__textarea__secondary", P = "forma-ui__textarea__label", Q = "forma-ui__textarea__total", r = {
  input: H,
  withIcon: J,
  readonly: K,
  secondary: O,
  label: P,
  total: Q
}, V = 300, so = A(({
  id: i = D(8),
  name: x,
  onChange: u,
  onFocus: e,
  onBlur: f,
  hidden: y,
  className: g,
  value: l,
  readOnly: h,
  viewStyle: S = "primary",
  maxLength: _ = 255,
  placeholder: C,
  required: I,
  meta: o,
  ...B
}, T) => {
  const n = M(null);
  G(n, T);
  const [R, F] = t(l ? String(l).length : 0), [c, p] = t(!1), [N, w] = t(!1);
  W(() => {
    n.current && k(n.current);
  }, [n]);
  const j = (s) => {
    u && u(s), F(s.target.value.length);
  }, E = (s) => {
    e && e(s), p(!0), w(!0);
  }, L = (s) => {
    f && f(s), w(!1), setTimeout(() => p(!1), V);
  }, U = c && (o == null ? void 0 : o.showClearButton) && !!l;
  return /* @__PURE__ */ d(
    q,
    {
      id: i,
      hidden: y,
      required: I,
      isShowClear: U,
      isShowButtons: c,
      isShowTooltip: N,
      isShowIcon: c || (o == null ? void 0 : o.showIconAlways),
      ...o,
      labelClass: b(o == null ? void 0 : o.labelClass, r.label),
      label: o != null && o.showLength ? /* @__PURE__ */ a(z, { children: [
        o == null ? void 0 : o.label,
        " ",
        /* @__PURE__ */ a("span", { className: r.total, children: [
          R,
          "/",
          _
        ] })
      ] }) : o == null ? void 0 : o.label,
      children: /* @__PURE__ */ d(
        "textarea",
        {
          ...B,
          id: i,
          name: x,
          onChange: j,
          onFocus: E,
          onBlur: L,
          className: b(
            r.input,
            r[S],
            g,
            ((o == null ? void 0 : o.icon) || (o == null ? void 0 : o.buttons) || (o == null ? void 0 : o.showClearButton)) && r.withIcon,
            (o == null ? void 0 : o.error) && "error",
            (o == null ? void 0 : o.success) && "success",
            h && r.readonly
          ),
          readOnly: h,
          maxLength: _,
          placeholder: C,
          value: l,
          ref: n
        }
      )
    }
  );
});
export {
  so as default
};
